// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import store from './store'
import VueI18n from 'vue-i18n'
import En from './lang/en'
import Zh from './lang/zh'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    en: En,
    zh: Zh
  }
})

Vue.config.productionTip = false

Vue.use(Vant)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    const lang = i18n.messages[i18n.locale]
    document.title = lang[to.meta.title]
  } else {
    console.warn('not find title data', to)
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js